import {InquiryMultiField} from "./inquiry_multi_field";

export const QuantityPeopleFieldConfig = {
    baseHtmlClass: 'inquiry_field--quantity_people',
    selector: '.inquiry_field--quantity_people'
}

export class QuantityPeopleField extends InquiryMultiField {

    static new(inquiryForm) {
        if (!inquiryForm.element) { return null }
        const element = inquiryForm.element.querySelector(QuantityPeopleFieldConfig.selector);
        if (element) { return new QuantityPeopleField(element, inquiryForm) }
    }

    constructor(id_or_element, inquiryForm) {
        super(id_or_element, inquiryForm);
    }

    getQuantityPeopleInputsValues() {
        let values = [];
        const adultsValue = this.getQuantityAdultsInputValue();
        if (adultsValue) { values.push(adultsValue) }
        const childrenValue = this.getQuantityChildrenInputValue();
        if (childrenValue) { values.push(childrenValue) }
        return values;
    }

    // Returns the single value as calculated by looking at each of the inputs.
    // For this people field we don't include the value for the `age_threshold` input.
    // This field's value is used to select products and only the quantity of people (adults + children) is relevant.
    getInputsValue() {
        const values = this.getQuantityPeopleInputsValues();
        if (values.length < 1) { return null }
        const sum = (accumulator, currentValue) => accumulator + currentValue;
        return (values.reduce(sum));
    }

    typecastValue(value) {
        if (value === '' || value === null) { return null }
        value = Number(value);
        return value;
    }

    hasValue() {
        return this.value !== null && this.value !== 0;
    }

    // Look up the human value based on the value code eg. 'NO_TOILET' => 'No Toilet'
    humanValue() {
        if (!this.value) { return }
        return (this.value === 1) ? `${ this.value } Person` : `${ this.value } People` ;
    }

    appendErrors() {
        const quantityAdultsInputValue = this.getQuantityAdultsInputValue();
        if (quantityAdultsInputValue == null || quantityAdultsInputValue === 0) { this.errors.push(`${ this.label } must have at least one adult.`) }
    }

    appendWarnings() {
    }

    getQuantityAdultsInput() {
        if (!this.inputElements) { this.setInputElements() }
        return this.inputElements[0]; // TODO - don't find input based on index!
    }

    getQuantityChildrenInput() {
        if (!this.inputElements) { this.setInputElements() }
        return this.inputElements[1]; // TODO - don't find input based on index!
    }

    getInsuranceAgeThresholdInput() {
        if (!this.inputElements) { this.setInputElements() }
        return this.inputElements[2]; // TODO - don't find input based on index!
    }

    getGreaterThanInsuranceAgeThresholdInput() {
        if (!this.inputElements) { this.setInputElements() }
        // TODO - don't find inputs based on index!
        const hiddenInput = this.inputElements[3]; // The hidden '0' value input.
        if (!hiddenInput) { return }
        const checkboxInput = this.inputElements[4]; // The visible checkbox that allows the user to select value '1'.
        if (!checkboxInput) { return }
        return (checkboxInput.checked === true ? checkboxInput : hiddenInput); // Return the input element that would be passed to the server.
    }

    getQuantityAdultsInputValue() {
        const input = this.getQuantityAdultsInput();
        const value = input ? input.value : null;
        return this.typecastValue(value);
    }

    getQuantityChildrenInputValue() {
        const input = this.getQuantityChildrenInput();
        const value = input ? input.value : null;
        return this.typecastValue(value);
    }

    getInsuranceAgeThresholdInputValue() {
        const input = this.getInsuranceAgeThresholdInput();
        const value = input ? input.value : null;
        return this.typecastValueToNumber(value);
    }

    getGreaterThanInsuranceAgeThresholdInputValue() {
        const input = this.getGreaterThanInsuranceAgeThresholdInput();
        const value = input ? input.value : null;
        return this.typecastValueToBoolean(value);
    }

}